import {
  FiltersFormValues,
  MateriaInstallationReportRequest,
  UpmDepartmentWithPlant
} from '@refra/modules/refra-flexible-report/types'

export const formatDate = (date: Date | null): string | null => {
  if (!date) return null
  return date.toISOString()
}

export const buildReportPayload = (
  values: FiltersFormValues,
  filteredKilns: UpmDepartmentWithPlant[]
): MateriaInstallationReportRequest => ({
  filters: {
    kilnUpmIds: filteredKilns.map((kiln) => kiln.upmId),
    manufacturerIds: values.refractoryManufacturerFilters.map(Number),
    refractoryIds: values.refractoryProductFilters.product.map(Number),
    classificationGroupIds: values.refractoryProductFilters.classification.map(Number),
    fromDate: formatDate(values.feedingDateFilter.from),
    toDate: formatDate(values.feedingDateFilter.to)
  }
})
